export const transferValueToInput = () => {
	//дата и время
	const when = document.querySelectorAll('.form__when');
	//календарь
	const date = document.getElementById('date'); //input
	const dateContent = document.getElementById('dateContent');
	const calendarDays = document.querySelectorAll('.calendar__days button');
	//время
	const time = document.getElementById('time'); //input
	const timeContent = document.getElementById('timeContent');
	const hours = document.querySelectorAll('.time__select time');
	//дата в блоке с выбором времени
	const selectedDate = document.getElementById('selectedDate');

	//console.log('isChangeMonth ', isChangeMonth)

	//сделать активным выбранный элемент
	const makeSelectActive = (arr) => {
		arr.forEach(el => {
			el.classList.contains('active') ? el.classList.remove('active') : null;
		})
	}
	

	// по клику по значению  передать его в инпут
	const selectValue = (values, input) => {
		
		let selectedValue = '';	

		values.forEach(val => {

			val.addEventListener('click', (e)=> {
				makeSelectActive(values)

				//если дата уже прошла/время занято, то ничего не делать
				if(e.target.classList.contains('disabled') || e.target.classList.contains('inactive')) return;

				//если клик по времени, то добавить активный класс выбранной дате
				if(e.target.tagName == "TIME") e.target.classList.add('active');

				//передать дату в инпут
				if(values == calendarDays) {
					clearTime();
					selectedValue = val.children[0].getAttribute('fulldate');//26.11.2021 так передать в инпут

					let d = selectedValue.slice(0,2); //26
					let m = selectedValue.slice(3,5); //11
					let y = selectedValue.slice(6); //2021
					var valueDateFormat = `${y}, ${m}, ${d}` //2021,11,26  так передать в new Date()

				}
				//передать время в инпут
				if(values == hours) selectedValue = val.getAttribute('datetime');

				input.value = selectedValue;

				//передать дату в блок с выбором времени
				if(input == date) selectedDate.innerHTML = new Date(valueDateFormat).toLocaleDateString('ru', {
					year: 'numeric',
					month: 'long',
					day: 'numeric'
				}).slice(0, -2); 
			})
		})
	}

	const clearTime = () => {
		date.addEventListener('focus', () => {
			time.value = ''
		})
	}
	

	//показать/спрятать содержимое - календарь или выбор времени по клику на инпут
	const toggleInner = (elem) => {
		let inner;

		if(elem == time) {
			inner = timeContent;
			dateContent.classList.add('off');
		}
		if(elem == date) {
			inner = dateContent;	
			timeContent.classList.add('off');
		}

		if(elem == time && date.value == '') return;//выбрать время можно только после выбора времени

		inner.classList.toggle('off');
	}	

	calendarDays.forEach(day => {
		day.addEventListener('click', ()=> {
			/* setTimeout(()=> {
				dateContent.classList.add('off')
			}, 100) */
			dateContent.classList.add('off')
		})
	})
	hours.forEach(time => {
		time.addEventListener('click', ()=> {
			timeContent.classList.add('off')
		})
	})
	
	//применить к дате и времени
	when.forEach(item => {

		if(item == date) selectValue(calendarDays, date);
		if(item == time) selectValue(hours, time);

		item.addEventListener('click', (e)=> {
			
			e.preventDefault()
			e.stopImmediatePropagation()
			toggleInner(item)
		}) 
	})
	/* $('.form__when').each(function () {
		$(this).on('click', (e) => {
			console.log(e)
			e.stopImmediatePropagation()
			this == date ? selectValue(calendarDays, date) : selectValue(hours, time)
			toggleInner(this)
		})
	}); */
}


